import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../context-store";
import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import JobPostingComponent from "../../components/company/job-posting/JobPostingComponent";
import jobPostingService from "../../services/company/job-posting-service";
import CompanyConfigurationModel from "../../models/company/CompanyConfigurationModel";
import IdNameModel from "../../models/common/IdNameModel";
import masterDataService from "../../services/master-data-service";
import toasterUtils from "../../utils/toaster-utils";
import designationService from "../../services/company/designation-service";
import modalUtils from "../../utils/modal-utils";
import { useHistory } from "react-router";
import { ScreenEnum } from "../../models/enums/StatusEnum";
import { Alert } from "@mui/material";
import domainService from "../../services/company/domain-service";

var companyConfigurationDefault: CompanyConfigurationModel = {
    companyId: "",
    countryId: 1
};

const JobPosting = () => {
    const history = useHistory();
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [companyConfiguration, setCompanyConfiguration] = useState<CompanyConfigurationModel>(companyConfigurationDefault);
    const [jobTypes, setJobTypes] = useState<IdNameModel[]>([]);
    const [assessmentTypes, setAssessmentTypes] = useState<IdNameModel[]>([]);
    const [domains, setDomains] = useState<IdNameModel[]>([]);
    const [primarySkills, setPrimarySkills] = useState<IdNameModel[]>([]);
    const [experiences, setExperiences] = useState<IdNameModel[]>([]);
    const [cities, setCities] = useState<IdNameModel[]>([]);
    const [designations, setDesignations] = useState<IdNameModel[]>([]);
    const [salaries, setSalaries] = useState<IdNameModel[]>([]);
    const [escalationStatusList, setEscalationStatusList] = useState<IdNameModel[]>([]);
    const [refreshEscalationStatus, setRefreshEscalationStatus] = useState<number>(2);

    useEffect(() => {
        fillJobTypes();
        fillAssessmentTypes();
        fillDomains();
        fillPrimarySkills();
        fillExperiences();
        fillSalaries();
        getCompanyConfiguration();
        getEscalationStatusList();
    }, []);

    const getCompanyConfiguration = () => {
        if (loggedInUser) {
            modalUtils.showLoader();
            jobPostingService.getCompanyConfiguration(loggedInUser.userId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setCompanyConfiguration(res.data);
                fillCities(res.data.countryId);
                fillDesignations(res.data.companyId);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const fillJobTypes = () => {
        masterDataService.loadJobTypes().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setJobTypes(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const fillAssessmentTypes = () => {
        masterDataService.loadInterviewTypes().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setAssessmentTypes(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const fillDomains = () => {
        if (loggedInUser) {
            domainService.fillDomains(loggedInUser.profileId).then((res) => {
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setDomains(res.items);
            }).catch((error) => {
                toasterUtils.showError(error);
            });
        }
    };

    const fillPrimarySkills = () => {
        masterDataService.loadPrimarySkills().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setPrimarySkills(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const fillExperiences = () => {
        masterDataService.loadExperiences().then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setExperiences(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const fillCities = (countryId: number) => {
        masterDataService.loadCities(countryId).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCities(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const fillDesignations = (companyId: string) => {
        designationService.fillDesignations(companyId).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setDesignations(res.items);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const fillSalaries = () => {
        masterDataService.loadSalaries().then((res) => {
            setSalaries(res);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const getEscalationStatusList = () => {
        masterDataService.loadStatusByScreen(ScreenEnum.EscalationsStatus).then((res) => {
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setEscalationStatusList(res.items);
            setRefreshEscalationStatus(refreshEscalationStatus * 5);
        }).catch((error) => {
            setRefreshEscalationStatus(refreshEscalationStatus * 5);
            toasterUtils.showError(error);
        });
    };

    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Post Job
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> Post Job </h4>
            </div>
            {(domains.length < 1 || designations.length < 1 || domains.length < 1) &&
                <Alert severity="info">Please Add Department, Designation & Domain to create a Job Posting.</Alert>
            }

            {jobTypes.length > 0 && assessmentTypes.length > 0 && domains.length > 0 &&
                primarySkills.length > 0 && experiences.length > 0 && cities.length > 0 && designations.length > 0
                && salaries.length > 0 && loggedInUser &&
                <JobPostingComponent
                    companyConfiguration={companyConfiguration}
                    jobTypes={jobTypes}
                    assessmentTypes={assessmentTypes}
                    domains={domains}
                    primarySkills={primarySkills}
                    experiences={experiences}
                    cities={cities}
                    designations={designations}
                    salaries={salaries}
                    escalationStatusList={escalationStatusList}
                    profileId={loggedInUser.profileId}
                    userId={loggedInUser.userId} />
            }
        </Layout>
    );
};
export default JobPosting;